interface PrintHeaderProps {
	reflectionTitle: string;
	createdDate: string;
}

export function PrintHeader({
	reflectionTitle,
	createdDate,
}: PrintHeaderProps) {
	const formatDate = (dateString: string) => {
		return new Date(dateString).toLocaleDateString("en-US", {
			year: "numeric",
			month: "long",
			day: "numeric",
		});
	};

	return (
		<div className="hidden print-header">
			<div className="mb-8">
				<div className="mb-6">
					<img
						src="/img/Reflection Journal logo and text.png"
						alt="Reflection Journal"
						className="h-8"
					/>
				</div>
				<div className="text-center">
					<h1 className="text-3xl font-bold text-gray-900 mb-2">
						{reflectionTitle}
					</h1>
					<p className="text-sm text-gray-500">
						Created: {formatDate(createdDate)}
					</p>
				</div>
			</div>
		</div>
	);
}
